module.exports = __webpack_public_path__ + "fonts/Clash-Regular.c9d3a50.woff";